import { useQuery } from "@tanstack/react-query";
import { searchDeals } from "@/api";
import { EsoDealFractal } from "@/types";

export const useSearchedDeals = (searchTerm?: string) => {
  const query = useQuery<EsoDealFractal[]>({
    queryKey: ["searchedDeals", searchTerm],
    queryFn: () => searchDeals(searchTerm!),
    staleTime: 1000 * 60 * 5,
    enabled: !!searchTerm,
  });

  return {
    ...query,
    data: query.data || [],
  }
};
